import classNames from 'classnames';
import React from 'react';

const HR = (props: React.HTMLProps<HTMLHRElement> & { margin?: string }) => {
  const { className = 'my-2', ...rest } = props;
  return <hr {...rest} className={classNames(className, ` `)} />;
};

export default React.memo(HR) as typeof HR;
